/**
 * 工作模式工具函数
 * 前台和后台共用
 * 统一使用大写格式：ONSITE, HOME_BASED, REMOTE, HYBRID
 */

import { WorkStyle, WORK_STYLE_KEY_MAP } from '../types';

/** 判断是否为到岗办公 */
export function isOnsiteWorkStyle(workStyle: string): boolean {
  return workStyle === 'ONSITE';
}

/** 判断是否为居家办公（需在指定城市） */
export function isHomeBasedWorkStyle(workStyle: string): boolean {
  return workStyle === 'HOME_BASED';
}

/** 判断是否为远程办公（无地域限制） */
export function isRemoteWorkStyle(workStyle: string): boolean {
  return workStyle === 'REMOTE';
}

/** 判断是否为混合办公 */
export function isHybridWorkStyle(workStyle: string): boolean {
  return workStyle === 'HYBRID';
}

/** 判断是否为非到岗工作模式（居家、远程或混合） */
export function isNonOnsiteWorkStyle(workStyle: string): boolean {
  return workStyle === 'HOME_BASED' || workStyle === 'REMOTE' || workStyle === 'HYBRID';
}

/** 获取工作模式的翻译键 */
export function getWorkStyleTranslationKey(workStyle: string): string {
  return WORK_STYLE_KEY_MAP[workStyle as WorkStyle] || workStyle;
}
